<template>
  <v-footer tag="footer">
    <v-container>
      <v-row class="cop-info">
        <div class="inner-cop">
          <v-icon icon="mdi-copyright"></v-icon>
          {{ COPYRIGHT_NAME }}
        </div>
        <div v-if="!isProd" style="color:#00cccc;font-weight: bolder;">
          Environment: {{ currentMode.toUpperCase() }} - Version: {{ version }}
        </div>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script setup>
const isProd = import.meta.env.PROD && import.meta.env.MODE === 'prod';
const currentMode = import.meta.env.MODE;
const version = __APP_VERSION__;
const COPYRIGHT_NAME = import.meta.env.VITE_COPYRIGHT_NAME;
</script>

<style lang="less" scoped>
.cop-info {
  align-items: center;
}

.inner-cop {
  flex-grow: 1;
}
</style>